export default "__VITE_ASSET__b781a362__"